<a class="logo-cont" [routerLink]="homeRoute()" aria-label="Go to home page">
  <app-icon
    [icon]="IconName.LOGO"
    class="logo logo--large"
    style="--icon-width: 44px; --icon-height: 44px"
  />
  <span class="emphasis">RetailTech</span>
</a>
